module.exports = __webpack_public_path__ + "static/media/s_v10_3.b275d547.mp3";